// @flow
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import branch from 'recompose/branch';
import renderComponent from 'recompose/renderComponent';
import path from 'ramda/es/path';
import { withTranslation } from 'react-i18next';

import Loader from 'app/components/Loader';
import { tariffsFetch } from 'app/actions/finances/tariffs';
import type { TariffType } from 'app/components/Tariff/Tariff';

import selectTariffs from './selectTariffs';


type Props = {
  service: string,
  studentId: number,
  currentSubId?: number,
}
export type CurrentTariffInfo = {
  bundleId?: number,
  tariffsInBundle: Array<number>,
  tariffId: number,
  kind: string,
  isTariffPartOf: (tariff: TariffType) => boolean,
}

const selectCurrentTariffInfo = (state, { currentSubId }: Props): CurrentTariffInfo => {
  const bundleId = path(['apps', 'subs', currentSubId, 'tariff_bundle_id'], state);
  const tariffsInBundle = (bundleId
    ? path(['finances', 'tariffs', 'bundles', bundleId, 'tariff_ids'], state) || []
    : []);
  const tariffId = path(['apps', 'subs', currentSubId, 'tariff_id'], state);
  const kind = path(['apps', 'tariffs', tariffId, 'kind'], state);

  return {
    bundleId,
    tariffsInBundle,
    tariffId,
    kind,
    isTariffPartOf: (tariff: TariffType) => {
      const { id, inside } = tariff;
      if (!bundleId) {
        return id === tariffId;
      }
      const isTargetTariffBundle = !!inside;
      return (isTargetTariffBundle
        ? id === bundleId
        : tariffsInBundle.includes(id));
    },
  };
};

export default compose(
  withTranslation(),

  connect(
    (state, props) => ({
      success: state.finances.tariffs.result === 'success',
      loading: state.finances.tariffs.loading,
      tariffs: selectTariffs(state, props),
      currentTariffInfo: selectCurrentTariffInfo(state, props),
    })
  ),

  lifecycle({
    componentDidMount() {
      const { dispatch, service, studentId, skipFetch } = this.props;
      if (!skipFetch) {
        dispatch(tariffsFetch(service, studentId));
      }
    },
  }),

  branch(
    ({ loading, success }) => (loading || !success),
    renderComponent(Loader)
  )
);
